/*
  blog-product-card.js — slots the cards rendered by snippets/blog-product-card.liquid into body placeholders.
  Blog Product Card, Session 1, 2026-09-11. Built on Apo.Ge - Dawn - V3.1.3 (#130007236657), LIVE since Travis published it 2026-09-12 00:41 UTC.
  Placeholder written in the article body (one line per card), editor-safe format (2026-09-12):
    <div class="bpc-placeholder bpc-for-{product-handle} bpc-replace-previous" hidden><p>per-post copy</p></div>
  The Shopify admin editor strips data-* attributes on save but keeps class and hidden, so classes carry the handle.
  The original data-attribute format is still read for posts not yet converted.
  For each placeholder inside .article-template__content: find the card with the matching data-handle,
  move the placeholder's inner HTML into the card's copy slot, move the card into the placeholder, show it,
  and hide the element before it when data-replace-previous is set (the legacy hand-typed callout).
  Cards left over stay in the container, which is then shown as "Featured in this post".
  Any error leaves that container visible so the products are never lost.
  Loaded with defer from sections/main-article.liquid.
*/
(function () {
  function slotBlogProductCards() {
    var container = document.querySelector('[data-blog-product-cards]');
    if (!container) return;
    try {
      var content = document.querySelector('.article-template__content');
      var placeholders = content ? content.querySelectorAll('[data-blog-product-card], .bpc-placeholder') : [];
      for (var i = 0; i < placeholders.length; i++) {
        var placeholder = placeholders[i];
        // Two placeholder formats. Preferred (survives the Shopify admin editor, which strips data-* attributes):
        //   <div class="bpc-placeholder bpc-for-{handle} bpc-replace-previous" hidden><p>copy</p></div>
        // Legacy: <div data-blog-product-card="{handle}" data-replace-previous="true" hidden><p>copy</p></div>
        var handle = placeholder.getAttribute('data-blog-product-card');
        var replacePrevious = placeholder.hasAttribute('data-replace-previous');
        if (!handle) {
          var classes = placeholder.className.split(/\s+/);
          for (var c = 0; c < classes.length; c++) {
            if (classes[c] === 'bpc-replace-previous') replacePrevious = true;
            else if (classes[c].indexOf('bpc-for-') === 0) handle = classes[c].slice(8);
          }
        }
        if (!handle) continue;
        var card = container.querySelector('.blog-product-card[data-handle="' + handle + '"]');
        if (!card) continue;
        var copy = card.querySelector('.blog-product-card__copy');
        if (copy) copy.innerHTML = placeholder.innerHTML;
        placeholder.innerHTML = '';
        placeholder.appendChild(card);
        placeholder.classList.add('blog-product-card-slot');
        placeholder.hidden = false;
        if (replacePrevious) {
          var previous = placeholder.previousElementSibling;
          if (previous) previous.hidden = true;
        }
      }
      if (container.querySelector('.blog-product-card')) {
        container.hidden = false;
        groupIntoRow(container.querySelectorAll('.blog-product-card'), container);
      } else if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
      groupAdjacentSlots(content);
    } catch (error) {
      container.hidden = false;
    }
  }

  // Cards that sit next to each other (only hidden elements between them, e.g. the old callouts) are wrapped in
  // .blog-product-card-row: a swipe carousel on mobile (same track as the landing-page card carousel), a plain
  // stack on desktop. Travis 2026-09-12.
  function groupAdjacentSlots(content) {
    if (!content) return;
    var slots = content.querySelectorAll('.blog-product-card-slot');
    var done = [];
    for (var i = 0; i < slots.length; i++) {
      var first = slots[i];
      if (done.indexOf(first) !== -1) continue;
      var run = [first];
      var node = first.nextElementSibling;
      while (node) {
        if (node.classList.contains('blog-product-card-slot')) {
          run.push(node);
          done.push(node);
        } else if (!node.hidden) {
          break;
        }
        node = node.nextElementSibling;
      }
      if (run.length < 2) continue;
      var row = document.createElement('div');
      row.className = 'blog-product-card-row';
      first.parentNode.insertBefore(row, first);
      var walker = first;
      var last = run[run.length - 1];
      while (walker) {
        var next = walker.nextElementSibling;
        row.appendChild(walker);
        if (walker === last) break;
        walker = next;
      }
    }
  }

  function groupIntoRow(cards, container) {
    if (cards.length < 2) return;
    var row = document.createElement('div');
    row.className = 'blog-product-card-row';
    container.appendChild(row);
    for (var i = 0; i < cards.length; i++) row.appendChild(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', slotBlogProductCards);
  } else {
    slotBlogProductCards();
  }
})();